import request from "../../utils/request";
import { Result } from "../../models/general";

// ..\Mowazaf.Server\Data\Marketing\MarketingLeadModels.cs (MarketingLeadView / MarketingLeadPageView)
export type MarketingLeadSource = 'sandbox-gate' | 'chatbot' | 'contact';

export interface MarketingLeadView {
  id: number;
  createdUtc: string;
  source: MarketingLeadSource | string;
  name: string;
  email: string;
  phone?: string | null;
  companyName: string;
  companySize?: string | null;
  country?: string | null;
  jobTitle?: string | null;
  interests: string[];
  message?: string | null;
  locale: string;
  pageUrl?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  transcript?: string | null;
  salesNotifiedUtc?: string | null;
}

export interface MarketingLeadPageView {
  items: MarketingLeadView[];
  totalCount: number;
  page: number;
  pageSize: number;
}

/** Operator only (server Policy = "Operator"): marketing-website leads, newest first. */
export async function getMarketingLeads(params: { source?: MarketingLeadSource | ''; page?: number; pageSize?: number }) {
  const res = await request.get<Result<MarketingLeadPageView>>(`MarketingLeads`, {
    params: {
      source: params.source || undefined,
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 100,
    },
  });
  return res.data;
}
